import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/types/supabase'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Variáveis de ambiente do Supabase não configuradas')
}

// Verifica se está rodando no navegador
const isBrowser = typeof window !== 'undefined'

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storageKey: 'ephemeral-cards-auth',
    storage: isBrowser ? localStorage : undefined,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})

// Listener para detectar erros de autenticação e fazer logout automático quando necessário
if (isBrowser) {
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'TOKEN_REFRESHED') {
      console.log('Token renovado com sucesso')
    }
    
    if (event === 'SIGNED_OUT') {
      console.log('Usuário deslogado')
    }
    
    // Se houver erro na renovação do token, fazer logout silencioso
    if (event === 'USER_UPDATED' && !session) {
      console.warn('Sessão expirada - redirecionando para login')
      // Limpar storage para evitar loops
      localStorage.removeItem('ephemeral-cards-auth')
      window.location.href = '/login'
    }
  })
} 